<template>
<div class="row vertical-10p">
  <div class="container">
    <img src="/static/img/logo.png" alt="LeadScorz" title="LeadScorz" class="center-block logo"> 
    <div class="text-center col-md-4 col-sm-offset-4">
      <form class="ui form loginForm" method="POST" v-on:submit.prevent="onSubmit">
        <div v-if="!ok && !error" class="alert alert-info">Please enter your new password.</div>
        <div v-else-if="ok" class="alert alert-success" role="alert">Thank you! Please use your new password to <router-link to="/login">Sign In</router-link></div>
        <div v-else-if="error" class="alert alert-danger text-left" role="alert">
          <ul>
            <li v-for="e in error_msg">{{ e }}</li>
          </ul>
        </div>
        <div v-if="!ok" class="input-group">
          <span class="input-group-addon"><i class="fa fa-at"></i></span> 
          <input v-model="password1" name="password1" placeholder="New Password" type="password" class="form-control" required>
        </div>
        <div v-if="!ok" class="input-group">
          <span class="input-group-addon"><i class="fa fa-at"></i></span> 
          <input v-model="password2" name="password2" placeholder="Repeat New Password" type="password" class="form-control" required>
        </div> 
        <button v-show="!ok" type="submit" class="btn btn-block btn-primary btn-lg">Submit</button>
      </form>
      <div>
        <router-link to="/login">Go back to Sign In</router-link>
      </div>      
    </div>
  </div>
</div>
</template>

<script>
export default {
  data: function () {
    return {
      error: false,
      ok: false,
      error_msg: ['There was an error while processing your request, please try again later.'],
      password1: null,
      password2: null
    };
  },
  methods: {
    onSubmit: function () {
      var self = this;
      let uid = this.$route.params.uid;
      let token = this.$route.params.token;

      self.ok = false;
      self.error = false;
      
      API.user.resetPasswordConfirm({
        uid: uid,
        token: token,
        new_password1: self.password1,
        new_password2: self.password2
        })
        .then(() => { self.ok = true; },
              (err) => {
                self.error = true;
                self.error_msg = [];
                for (const k in err.data) {
                  if (k == 'token' || k == 'uid') {
                    self.error_msg = ['This link has expired, please try again.'];
                  }
                  else {
                    self.error_msg = self.error_msg.concat(err.data[k]);
                  }
                }
              })
        .catch(() => { self.error = true; self.error_msg = ['Unexpected error! Please try again later.']; });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
html, body, .container-table {
  height: 100%;
  background-color: #eee;
}
.container-table {
  display: table;
  color: white;
}
.vertical-center-row {
  display: table-cell;
  vertical-align: middle;
}

.form {
  background: #fff;
  padding: 35px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.08);
  font-size: 1.1em;
  margin-bottom: 30px;
}

.vertical-20p {
  padding-top: 20%;
}
.vertical-10p {
  padding-top: 10%;
}
.loginForm .input-group {
  padding-bottom: 1em;
  height: 4em;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
}
.input-group input {
  height: 3em;
  color: #002754 !important;
  font-size: 1.1em;
}

.input-group .input-group-addon {
  border-radius: 0;
  width: 37px;
}
.text-red {
  color: red !important;
}

.btn-primary {
  margin-top: 30px;
  border: 1px solid #ff4d50;
  color: #ff4d50;
  background: #fff;
}

.btn-primary:hover, .btn-primary:focus {
  color: #fff;
  background: #ff4d50;
}
</style>



// WEBPACK FOOTER //
// ResetPasswordConfirm.vue?458fb891